import React, { useState } from 'react';
import './ContactForm.css';
import { useForm } from 'react-hook-form';
import { useInView } from 'react-intersection-observer';

function ContactForm() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { ref: formRef, inView: formInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const { ref: mapRef, inView: mapInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await fetch('https://formspree.io/f/mrbzzldj', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setSubmitted(true);
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form-map-container">
      
      <div ref={mapRef} className={`map-container ${mapInView ? 'animate' : ''}`}>
      <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.2414953399834!2d77.9920107!3d27.2043453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3974779af6cb7cef%3A0xe02e9fe2e36d2145!2sDr.%20Vaishali%20Tandon!5e0!3m2!1sen!2sin!4v1629303484180!5m2!1sen!2sin"
  width="100%"
  height="100%"
  allowFullScreen=""
  loading="lazy"
  title="Google Maps Location"
></iframe>

      </div>
      <div ref={formRef} className={`contact-form-container ${formInView ? 'animate' : ''}`}>
        <h1 className='text-start text-dark'><b>Enquiry Form</b></h1><br />
        {submitted ? (
          <p className="success">Thank you for your message. We will get back to you soon.</p>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
              <div>
                <label htmlFor="name">Patient Name</label>
                <input type="text" id="name" {...register("name", { required: true })} aria-invalid={errors.name ? "true" : "false"} />
                {errors.name && <p className="error">Name is required</p>}
              </div>
              <div>
                <label htmlFor="email">Email</label>
                <input type="email" id="email" {...register("email", { required: true, pattern: /^\S+@\S+$/i })} aria-invalid={errors.email ? "true" : "false"} />
                {errors.email && <p className="error">Please enter a valid email address</p>}
              </div>
              <div>
                <label htmlFor="phone">Mob.</label>
                <input type="tel" id="phone" {...register("phone", { required: true })} aria-invalid={errors.phone ? "true" : "false"} />
                {errors.phone && <p className="error">Phone number is required</p>}
              </div>
              <div>
                <label htmlFor="date">Appointment Date</label>
                <input type="date" id="date" {...register("date", { required: true })} aria-invalid={errors.date ? "true" : "false"} />
                {errors.date && <p className="error">Date is required</p>}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" {...register("message", { required: true })} aria-invalid={errors.message ? "true" : "false"}></textarea>
              {errors.message && <p className="error">Message is required</p>}
            </div>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? <span className="spinner"></span> : 'Submit'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default ContactForm;
